import { jsx as _jsx } from "react/jsx-runtime";
import { GridContainer } from '../../layout/GridContainer';
import { gridColumns } from '../constants';
export const GridList = ({ children, itemMinWidth, testId }) => {
    const columns = gridColumns(itemMinWidth);
    return (_jsx(GridContainer, { columns: columns, testId: testId, gap: true, children: children }));
};
